import React from 'react';
import { useSelector } from 'js/store/hooks';
import { useDetectLanguage } from 'js/hooks/user';
import { WebContent } from 'js/components/system/WebContent';
import { MAINTENANCE_MODE_REDUCER } from 'js/store/constants';

export const MaintenancePage: React.FC = () => {
    const webContentId = useSelector((state) => state[MAINTENANCE_MODE_REDUCER].webContentId);

    useDetectLanguage();

    return <WebContent id={webContentId} showLoader={false} />;
};
